import { Directive } from '@angular/core';
import { classes } from '@spartan-ng/helm/utils';

@Directive({
	selector: 'brn-switch-thumb[hlm],[hlmSwitchThumb]',
})
export class HlmSwitchThumb {
	constructor() {
		classes(
			() =>
				'bg-background dark:group-data-[state=unchecked]:bg-foreground dark:group-data-[state=checked]:bg-primary-foreground pointer-events-none block size-4 rounded-full shadow-md ring-0 transition-transform group-data-[state=checked]:translate-x-4 group-data-[state=unchecked]:-translate-x-1',
		);
	}
}
